import { setRangeMax } from './helpers';

export const setRoomAreaMax = setRangeMax('room_area');
